import {useQuery} from "@tanstack/react-query"
import {pckGetUsers} from "@/library/api/users-requests"
import useAuth from "@/library/auth/_hook.auth"
import Button from "@/components/ui-kit/button"

export default function UsersList() {
    const {token} = useAuth()

    const usersQuery = useQuery<User[]>({
        queryKey: ["users"],
        queryFn: () => pckGetUsers(token)
    })

    if (usersQuery.isError)
        return <>{usersQuery.error}</>

    if (!usersQuery.data)
        return <></>

    return <div className="table table-responsive">
        <table width="100%" cellPadding={0} cellSpacing={0} border={0}>
            <thead>
            <tr>
                <th align="center">Valg</th>
                <th align="center">Bilde</th>
                <th align="left">Navn</th>
                <th align="left">E-post</th>
                <th align="left">Bekreftet e-post</th>
                <th align="left">Bekreftet mobilnr.</th>
                <th align="left">2-Faktor</th>
            </tr>
            </thead>
            <tbody>
            {/*<tr>
                <td align="center"><Button color="default" className="square"><i className="far fa-plus"/></Button></td>
                <td align="center">
                    <div className="picture picture--round">
                        <img src={'/dummy-profile.webp'} alt=""/>
                    </div>
                </td>
                <td><input type="text" placeholder="Ola Normann"/></td>
                <td><input type="email" placeholder="ola@normann.no"/></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>*/}
            {usersQuery.data?.map((user) =>
                <tr key={user.id}>
                    <td align="center"><Button color="default" className="square"><i className="far fa-ellipsis"/></Button></td>
                    <td align="center"><div className="picture picture--round">
                        <img src={user.avatarUrl ?? '/dummy-profile.webp'} alt=""/>
                    </div></td>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>{user.emailConfirmed ? "Ja" : "Nei"}</td>
                    <td>{user.phoneNumberConfirmed ? "Ja" : "Nei"}</td>
                    <td>{user.twoFactorEnabled ? "Ja" : "Nei"}</td>
                </tr>
            )}
            </tbody>
        </table>
    </div>
}
